/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnableAltArtRequest } from '../../models/enable-alt-art-request';
import { EnableAltArtResponse } from '../../models/enable-alt-art-response';

export interface AdminServiceEnableAltArt$Params {
      body: EnableAltArtRequest
}

export function adminServiceEnableAltArt(http: HttpClient, rootUrl: string, params: AdminServiceEnableAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<EnableAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceEnableAltArt.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnableAltArtResponse>;
    })
  );
}

adminServiceEnableAltArt.PATH = '/api/v3/gateway/admin/alt_art/enable';
